import { render, staticRenderFns } from "./multi-choice.vue?vue&type=template&id=276c3e58&scoped=true&"
import script from "./multi-choice.vue?vue&type=script&lang=js&"
export * from "./multi-choice.vue?vue&type=script&lang=js&"
import style0 from "./multi-choice.vue?vue&type=style&index=0&id=276c3e58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276c3e58",
  null
  
)

component.options.__file = "multi-choice.vue"
export default component.exports